import React from 'react';
import { faShareAlt } from '@fortawesome/pro-solid-svg-icons/faShareAlt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ShareAltSolidIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faShareAlt} {...props} />;
}
